let registeredStore: $TSFixMe;

export function registerStore(_store: $TSFixMe) {
  registeredStore = _store;
}

export function store() {
  return registeredStore;
}
